<div class="container-fluid contract-list" [ngClass]="{ 'has-app-banner': showAppBanner && !cameFromNewLocal }">
    <div class="flex-grow-0">
        <div class="d-flex flex-row justify-content-between">
            <a
                class="btn-back d-flex justify-content-end mt-3 mr-2 mt-md-4 mr-lg-3"
                *ngIf="!!cameFromNewLocal"
                (click)="openNewLocalModal()"
            >
                <i class="icon-edponline-Bop-078 rotate-180" aria-hidden="true"></i>
            </a>

            <a
                class="btn-close d-flex justify-content-end mt-2 mr-2 mt-md-4 mr-lg-3"
                *ngIf="data.showClose && !cameFromNewLocal"
                data-modal="dismiss()"
                (click)="dismiss()"
            >
                <i class="icon-edponline-Bop-071 color-brownish-grey" aria-hidden="true"></i>
            </a>
        </div>

        <div
            class="d-flex flex-row justify-content-between contract-list-header align-items-start"
            [ngClass]="{ 'mt-5 mt-md-0': data.showClose && !cameFromNewLocal, 'mt-4 mt-md-0': !!cameFromNewLocal }"
        >
            <ng-container *ngIf="!cameFromNewLocal">
                <div class="d-flex flex-column">
                    <edp-contract-list-welcome></edp-contract-list-welcome>
                    <span *ngIf="!isSearching">
                        {{ "pt.edp.edponline.contract.list.consumption.local.select" | translate }}
                        {{ "pt.edp.edponline.contract.list.consumption.local.wanted" | translate }}
                    </span>
                </div>
            </ng-container>
            <span *ngIf="!isSearching && !!cameFromNewLocal">
                {{ "pt.edp.edponline.contract.list.consumption.local_plural" | translate }}
            </span>
        </div>

        <ng-container *ngIf="isSearchable">
                <ng-container *ngTemplateOutlet="searchSpanish"></ng-container>
        </ng-container>
    </div>

    <div class="row row-cols-md-2 row-cols-lg-3 row-cols-xxl-5 edp-scroll-disabled contract-list-body">
        <ng-container *ngIf="tempContracts?.length && tempContracts?.length > 0; else templateSyncWallet">
            <ng-container *ngFor="let contract of tempContracts">
                <edp-es-contract-local-card
                    class="col mb-2 mb-md-4 d-block"
                    [contract]="contract"
                    [selected]="selectedContract"
                    [biggerCard]="true"
                    (selectedContract)="selectContract($event)"
                ></edp-es-contract-local-card>
            </ng-container>
            <ng-container *ngFor="let pendingContract of pendingContracts">
                <edp-card-pending-approval [pendingContract]="pendingContract" class="col mb-4 d-block padding-02"></edp-card-pending-approval>
            </ng-container>
        </ng-container>

    </div>
</div>

<ng-template #templateSyncWallet>
    <div class="col mb-2 mb-md-4 d-block">
        <div class="edp-card-contract card edp-card-sync-wallet h-100 justify-content-center" (click)="syncWallet()">
            <div class="mt-2 text-center">
                <span [innerHTML]="'pt.edp.edponline.contract.list.sync.wallet' | translate"></span>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #searchDefault>
    <div class="d-flex flex-row justify-content-between align-items-start contract-list-filter">
        <ng-container *ngIf="!!isSearching">
            <input type="text" class="w-100 search-input"
                placeholder="{{ 'pt.edp.edponline.contract.list.filter.search.consumption.place' | translate }}"
                [(ngModel)]="searchByText" (keyup)="onKeyPress($event)" />

            <button class="btn btn-search py-0" (click)="showSearchContract()">
                <span class="d-block pt-2">
                    {{ "pt.edp.edponline.contract.list.filter.close" | translate }}
                </span>
            </button>
        </ng-container>
        <ng-container *ngIf="!isSearching">
            <edp-contract-list-filter></edp-contract-list-filter>
            <button class="btn btn-search py-0" (click)="showSearchContract()">
                <i class="icon icon-edponline-Bop-055" aria-hidden="true"></i>
            </button>
        </ng-container>
    </div>
</ng-template>

<ng-template #searchSpanish>
    <ng-container *ngIf="!!isSearching">
        <div class="d-flex flex-row justify-content-between align-items-start contract-list-filter">
                <input type="text" class="w-100 search-input"
                    placeholder="{{ 'pt.edp.edponline.contract.list.filter.search.consumption.place' | translate }}"
                    [(ngModel)]="searchByText" (keyup)="onKeyPress($event)" />

                <button class="btn btn-search py-0" (click)="showSearchContract()">
                    <span class="d-block pt-2">
                        {{ "pt.edp.edponline.contract.list.filter.close" | translate }}
                    </span>
                </button>
        </div>
    </ng-container>

    <div class="d-flex flex-row justify-content-between align-items-center">
        <span class="contract-list-subheader mb-3" [ngClass]="{ 'subheader-filters': isSearchable }">
            <span class="contract-title">{{ tempContracts ? tempContracts.length : 0 }}</span>
            {{ "pt.edp.edponline.contract.list.consumption.local_plural" | translate }}
        </span>
        <ng-container *ngIf="!isSearching">
            <button class="btn btn-search py-0" (click)="showSearchContract()">
                <i class="icon icon-edponline-Bop-055" aria-hidden="true"></i>
            </button>
        </ng-container>
    </div>
</ng-template>
